<svg
  *ngIf="brandKey === 'x'; else faIcon"
  class="rak-brand-icon rak-brand-icon-x"
  [class.rak-brand-icon-lg]="size === 'lg'"
  viewBox="0 0 24 24"
  role="img"
  focusable="false"
  [attr.aria-label]="label"
><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>

<ng-template #faIcon>
  <i class="fa fa-{{name}}" [class.fa-lg]="size === 'lg'" [attr.aria-label]="label"></i>
</ng-template>
